import { createReducer } from '../utils/createReducer';
import { request } from "../utils/request";
import { Toast } from "antd-mobile";

const dict = {
    Baohe: 0,
    WeChat: 1,
    Moments: 2,
    DingTalk: 3,
    Browser: 4,
    CopyLink: 5,
}

const namespace: string = "article";

const initialState = {
    shareConfig: null
};

const reducer = {
    onGetShareConfigSuc(state: any, action: any) {
        if (action.error || action.result.error) {
            return state;
        }

        const { enable, channels } = action.result;
        let menus: never[] = [];
        if (enable) {
            menus = channels.map((channel: string) => dict[channel]).filter((_?: number) => typeof _ !== 'undefined');
        }
        if (global.zt && global.zt.setShareMenu) {
            global.zt.setShareMenu({
                menus
            });
        }

        return { ...state, shareConfig: action.result };
    },

    onGetShareConfigErr(state: any, action: any) {
        // Toast.fail("获取附件失败", 2);
        return { state };
    }
};

export default createReducer(initialState, reducer, namespace)

export function getShareConfig(action: any): Actions {
    return {
        types: ["article/onGetShareConfig", "article/onGetShareConfigSuc", "article/onGetShareConfigErr"],
        promise: request(`/get_article_share`, {
            method: "GET", body: {
                uuid: action.articleId
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/reducers/article.ts